import DrEventsList from './DrEventsList';

export default DrEventsList;
